import { Injectable } from '@angular/core';
import { ENV } from '@app/env';

import { APP_CONFIG } from '../../app.config';
import { ManagerByPlaceType } from '../../shared/enums/manager-by-place.enum';
import { UtilHelper } from '../../shared/helpers/utils.helper';
import { Error } from '../../shared/models/error.model';
import { ParamKey, ParamType } from '../../shared/models/params.model';
import { RequestService } from '../../shared/services/request.service';
import { Store } from '../store/models/store.model';
import { Place } from './models/place.model';

@Injectable()
export class PlaceService {

	constructor(
		private requestService: RequestService
	) { }

	getPlaceData(uuid: string): Promise<Place> {
		return new Promise((resolve, reject) => {
			const urlRequest: string = this.requestService.buildUrlPathParams({ uuid: uuid }, APP_CONFIG.WEBSERVICE.GET_PLACE_DATA);
			this.requestService.getData(urlRequest).then((response: Place) => {
				console.log(response);
				resolve(new Place(response));
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	update(place: Place): Promise<any> {
		return new Promise((resolve, reject) => {
			const data: any = JSON.parse(JSON.stringify(place));
			if (!place.saveIdentity) {
				data.cnpj = UtilHelper.unmask(data.cnpj);
				data.phone = UtilHelper.unmask(data.phone);
				data.contactPhone = UtilHelper.unmask(data.contactPhone);
				data.cpf = UtilHelper.unmask(data.cpf);
				data.zipCode = UtilHelper.unmask(data.zipCode);
				data.status = place.status['code'] || place.status;
			}
			if (data.authority) {
				delete data.authority;
			}
			delete data.descriptionTranslations;
			
			console.log(JSON.stringify(data));
			this.requestService.putData(APP_CONFIG.WEBSERVICE.UPDATE_PLACE, data).then((response: any) => {
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	getStores(id: number): Promise<Array<Store>> {
		return new Promise((resolve, reject) => {
			this.requestService.getData(APP_CONFIG.WEBSERVICE.GET_ESTABLISHMENTS_FROM_PLACE + id).then((response: any) => {
				console.log(response);
				const establishments: Array<Store> = [];
				if (response && response.length > 0) {
					response.forEach((e: Store) => {
						establishments.push(new Store(e));
					});
				}
				resolve(establishments);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	removeStoreFromPlace(storeId: number, placeId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			const data: any = {
				id: storeId,
				placeId: placeId
			};
			this.requestService.postData(APP_CONFIG.WEBSERVICE.REMOVE_STORE_FROM_PLACE, data).then((response: any) => {
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	addStoreToPlace(storeId: number, placeId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			const data: any = {
				id: storeId,
				placeId: placeId
			};
			this.requestService.postData(APP_CONFIG.WEBSERVICE.ADD_STORE_TO_PLACE, data).then((response: any) => {
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	manageStore(storeId: number, managerType: ManagerByPlaceType): Promise<any> {
		return new Promise((resolve, reject) => {
			const data: any = {
				referenceId: storeId,
				type: ParamType.STORE,
				key: ParamKey.MANAGER_BY_PLACE,
				value: managerType
			};
			this.requestService.postData(APP_CONFIG.WEBSERVICE.SAVE_PARAMS, [data]).then((response: any) => {
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}

	getStoresNearby(lat: number, lon: number, radius: number, page: number, size: number): Promise<Array<any>> {
		return new Promise((resolve, reject) => {
			const params: any = {
				lat: lat,
				lon: lon,
				radius: radius,
				page: page,
				size: size
			};
			const urlRequest: string = this.requestService.buildUrlPathParams(params, APP_CONFIG.WEBSERVICE.GET_NEARBY_ESTABLISHMENTS);
			this.requestService.getData(urlRequest).then((response: Array<Store>) => {
				console.log(response);
				const establishments: Array<Store> = [];
				if (response && response.length > 0) {
					for (const e of response) {
						// Não mostra o estabelecimento de teste da Fastget
						if (ENV.mode === "PROD" && e.id === 4) {
							continue;
						}
						// Só mostra estabelecimentos que não tem vínculo com nenhum place
						if (!e.place) {
							establishments.push(new Store(e));
						}
					}
				}
				resolve(establishments);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/place/place.service.ts